<form [formGroup]="filterForm" class="flex flex-row gap-x-8 basis-full">
  <mat-checkbox formControlName="available">Available</mat-checkbox>
  <mat-checkbox formControlName="hires">Hires</mat-checkbox>
  <mat-checkbox formControlName="bookings">Bookings</mat-checkbox>
</form>
